import React, { useEffect } from "react";
import { Typography } from "@mui/material";
import WhiteArrowRight from "../../assets/images/WhiteArrowRight.png";
import GrayArrowLeft from "../../assets/images/GrayArrowLeft.png";
import TrendTreat1 from "../../assets/images/TrendTreat1.png";
import { convertImagePathToUrl } from "../../utils";

import "aos/dist/aos.css";

export const TrendNewsCrousal = ({ trendNews = [] }) => {
  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll(".aos-init");
      elements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const triggerPoint = window.innerHeight / 2;
        if (rect.top < triggerPoint) {
          el.style.transitionDuration = "0.2s";
          el.style.transitionTimingFunction = "cubic-bezier(0.4, 0, 1, 2)";
          el.classList.add("aos-animate");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (!trendNews || trendNews.length === 0) {
    return (
      <div id="TREND Trends">
        <Typography
          className="text-white text-center py-10"
          style={{ fontSize: 36, fontFamily: "Montserrat" }}
        >
          No Trend News Available
        </Typography>
      </div>
    );
  }

  const groupByYear = (subHeadings) => {
    const groupedByYear = {};
    subHeadings.forEach((item) => {
      const year = item.sub_heading;
      if (year && /^\d{4}$/.test(year)) {
        if (!groupedByYear[year]) {
          groupedByYear[year] = [];
        }
        groupedByYear[year].push({
          desc: item.sub_heading_desc,
          url: item.sub_heading_url,
        });
      }
    });

    const sortedYears = Object.keys(groupedByYear).sort((a, b) => b - a);
    const formattedGroups = {};
    sortedYears.forEach((year) => {
      const points = groupedByYear[year]
        .filter((item) => item.desc)
        .flatMap((item) =>
          item.desc
            .split(/[\r\n]+/)
            .map((point) => point.trim())
            .filter((point) => point)
            .map((point) => ({
              content: point,
              url: item.url,
            }))
        )
        .map((point) => `<li style="margin-bottom:8px;">${point.content}</li>`)
        .join("");
      const bulletList = points
        ? `<ul style="padding-left: 20px; list-style-type: disc;">${points}</ul>`
        : "";
      formattedGroups[year] = bulletList;
    });

    return { sortedYears, formattedGroups };
  };

  return (
    <div>
      {trendNews.map((detail, detailIndex) => {
        const subHeadings = detail?.sub_headings || [];
        if (subHeadings.length === 0) return null;

        const isOdd = detailIndex % 2 === 0;
        const sectionImage =
          subHeadings[0]?.sub_heading_bg_image || TrendTreat1;
        const subHeadingImages = subHeadings
          .map((subHeading) => subHeading.sub_heading_image)
          .filter((image) => image != null);

        const { sortedYears, formattedGroups } = groupByYear(subHeadings);

        return (
          <div
            key={detail.detail_id}
            id={isOdd ? "TREND News" : ""}
            className="trendNews"
            style={{ overflow: "hidden" }}
          >
            <div
              className="h-full md:h-[700px] flex flex-col md:flex-row justify-between pl-0 md:pl-24 w-full"
              data-aos={isOdd ? "fade-right" : "fade-left"}
              data-aos-delay="300"
            >
              {/* Left Section */}
              <div
                className="hidden md:flex justify-center items-center"
                style={{ flex: 1, backgroundColor: isOdd ? "" : "" }}
              >
                {isOdd ? (
                  subHeadingImages.length > 0 ? (
                    subHeadingImages
                      .slice(0, 1)
                      .map((image, index) => (
                        <img
                          key={index}
                          src={convertImagePathToUrl(image)}
                          alt={`Subheading Image ${index + 1}`}
                          className="object-contain max-w-[434px] max-h-[641px]"
                        />
                      ))
                  ) : (
                    <img
                      src={convertImagePathToUrl(sectionImage)}
                      alt=""
                      className="object-contain max-w-[434px] max-h-[641px]"
                    />
                  )
                ) : (
                  <img
                    src={GrayArrowLeft}
                    className="h-full ml-auto leftArrowStyle"
                    alt=""
                  />
                )}
              </div>

              {/* Middle Section: Text content grouped by year */}
              <div
                className="flex flex-col items-center"
                style={{
                  flex: 1.75,
                  backgroundColor: isOdd ? "#FFFFFF" : "#EBEEF3",
                }}
              >
                <div
                  className="py-10 mx-20 lg:mx-0"
                  style={{ maxWidth: "650px" }}
                >
                  {subHeadingImages.length > 0 && (
                    <div className="md:hidden flex justify-center mb-6">
                      {subHeadingImages.slice(0, 1).map((image, index) => (
                        <img
                          key={index}
                          src={convertImagePathToUrl(image)}
                          alt={`Subheading Image ${index + 1}`}
                          className="w-full max-w-[480px] rounded-lg"
                        />
                      ))}
                    </div>
                  )}
                  {isOdd && (
                    <Typography
                      className="py-10 text-4xl font-bold"
                      style={{ fontFamily: "Montserrat" }}
                    >
                      TREND News
                    </Typography>
                  )}
                  {sortedYears.map((year) => (
                    <div key={year} style={{ marginBottom: "16px" }}>
                      <Typography
                        style={{
                          fontFamily: "Montserrat",
                          fontSize: 14,
                          fontWeight: 600,
                          paddingBottom: "4px",
                          paddingTop: "10px",
                        }}
                      >
                        {year}:
                      </Typography>
                      {formattedGroups[year] && (
                        <Typography
                          style={{
                            fontFamily: "Montserrat",
                            fontSize: 14,
                            fontWeight: 400,
                            whiteSpace: "normal",
                            paddingBottom: "8px",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: formattedGroups[year],
                          }}
                        />
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* Right Section */}
              <div
                className="hidden md:flex justify-center items-center"
                style={{
                  flex: 1,
                  backgroundColor: isOdd ? "#EBEEF3" : "#EBEEF3",
                }}
              >
                {isOdd ? (
                  <img
                    src={WhiteArrowRight}
                    className="h-full mr-auto leftArrowStyle"
                    alt=""
                  />
                ) : subHeadingImages.length > 0 ? (
                  subHeadingImages
                    .slice(0, 1)
                    .map((image, index) => (
                      <img
                        key={index}
                        src={convertImagePathToUrl(image)}
                        alt={`Subheading Image ${index + 1}`}
                        className="object-contain max-w-[434px] max-h-[641px]"
                      />
                    ))
                ) : (
                  <img
                    src={convertImagePathToUrl(sectionImage)}
                    alt=""
                    className="object-contain max-w-[434px] max-h-[641px]"
                  />
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
